<template>
  <div v-show="show">
    <header v-show="isComponentCreated" class="logged">
      <div class="logo">
        <router-link to="/home" :class="['logo-header', getActiveTabClass('/home')]">
          <img :src="getTranslations.logo_for_branded_projects_only_header || getTranslations.logo_for_branded_projects || 'static/images/logos/logo_white.svg'" @click="updateBM" alt="">
        </router-link>
      </div>
      <div class="header_right">
        <a style="cursor:pointer" v-if="!hideStore" @click.prevent=goToStore><img id="store" src="/static/images/menu/store.svg" alt="Store"></a>
        <a style="cursor:pointer" @click.prevent=goToProfile><img id="profile" src="/static/images/menu/profile.svg" alt="Profile"></a>
        <a style="cursor:pointer" @click.prevent=goToNotifications>
          <img
            v-show="hasUnreadNotifications"
            id="notification_full"
            src="/static/images/menu/notification_full.svg"
            alt="Notifications"
          />

          <img
            v-show="!hasUnreadNotifications"
            id="notification_empty"
            src="/static/images/menu/notification_empty.svg"
            alt="Notifications"
          />
        </a>
<!--        <a style="cursor:pointer" @click.prevent=goToNotifications><img id="notification_empty" src="/static/images/menu/notification_empty.svg" alt="Notifications"></a>-->
<!--        <img id="notification_empty" src="/static/images/menu/notification_empty.svg" alt="Notifications" @click=goToNotifications>-->
        <!--            <a style="cursor:pointer" @click.prevent=goToNotifications><img src="static/images/icon-notifications.svg"></a>-->
        <!--            <nav class="main-nav">-->
        <!--              <ul v-if="!hideLangSelection" class="main-nav__lang" id="get_started_menu">-->
        <!--                <li class="dropdown">-->
        <!--                  <a><div class="icon-globe"><img src="static/images/icon-globe.svg" alt=""></div></a>-->
        <!--                  <ul>-->
        <!--                    <li v-for="(value, key) in availableLocales" :key="key" style="cursor:pointer">-->
        <!--                      <a @click.prevent="changeLanguage(key)" :class="getActiveTabLocale(key)">{{ value }} </a>-->
        <!--                    </li>-->
        <!--                  </ul>-->
        <!--                </li>-->
        <!--              </ul>-->
        <!--            </nav>-->
        <div v-if="!hideLangSelection" class="language-selector" id="languageSelector">
          <img id="languageIcon" src="static/images/menu/language.svg"  alt="Language">
          <i id="chevronIcon" class="fas fa-chevron-down"></i>
          <ul class="language-dropdown">
            <li v-for="(value, key) in availableLocales" :key="key" style="cursor:pointer">
              <a @click.prevent="changeLanguage(key)" :class="getActiveTabLocale(key)">{{ value }} </a>
            </li>
          </ul>
        </div>
        <div class="vert_sep"></div>
        <div class="menu-toggle" id="menuToggle">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
      </div>
    </header>
    <nav id="navMenu" class="nav-menu">
      <ul>
        <div class="menu_open_top">
          <li> <!--PRIZES-->
            <router-link to="/home/prizes">
              <img src="/static/images/menu/menu_item_prizes.png" alt="Menu Icon">
              <div class="flex-column">
                <div class="menu_title bold">{{ getTranslations.home_home_prizes }}</div>
                <div class="menu_desc">{{getTranslations.home_home_prizes_desc}}</div>
              </div>
              <i class="fas fa-chevron-right"></i>
            </router-link>
          </li>
          <li v-if="!hideLeaderboard"> <!-- PRIZES & LEADERBOARDS -->
            <router-link to="/home/prizesAndLeaderBoards">
              <img src="/static/images/menu/menu_item_leaderboards.png" alt="Menu Icon">
              <div class="flex-column">
                <div class="menu_title bold">{{ getTranslations.home_home_prizes_and_leaderboards }}</div>
                <div class="menu_desc">{{ getTranslations.home_home_prizes_and_leaderboards_desc }}</div>
              </div>
              <i class="fas fa-chevron-right"></i>
            </router-link>
          </li>
          <li v-if="!hideStore"> <!-- STORE -->
            <router-link to="/home/store">
              <img src="/static/images/book.png" alt="Menu Icon">
              <div class="flex-column">
                <div class="menu_title bold">{{ getTranslations.home_home_store }}</div>
                <div class="menu_desc">{{ getTranslations.home_home_store_desc }}</div>
              </div>
              <i class="fas fa-chevron-right"></i>
            </router-link>
          </li>
          <li v-if="!hideWinners"> <!-- WINNERS -->
            <router-link to="/home/winners">
              <img src="/static/images/menu/menu_item_winners.png" alt="Menu Icon">
              <div class="flex-column">
                <div class="menu_title bold">{{ getTranslations.home_home_winners }}</div>
                <div class="menu_desc">{{ getTranslations.home_home_winners_desc }}</div>
              </div>
              <i class="fas fa-chevron-right"></i>
            </router-link>
          </li>
          <li> <!-- PROFILE -->
            <router-link to="/home/profile">
              <img src="/static/images/menu/menu_item_profile.png" alt="Menu Icon">
              <div class="flex-column">
                <div class="menu_title bold">{{ getTranslations.home_home_profile }}</div>
                <div class="menu_desc">{{ getTranslations.home_home_profile_desc }}</div>
              </div>
              <i class="fas fa-chevron-right"></i>
            </router-link>
          </li>
<!--          TO-DO IF WE NEED CHANGE LANGUAGE ON NAV MENU-->
<!--          <li>-->
<!--            <a href="#">-->
<!--              <img src="./assets/images/menu/language_selected.svg" alt="Menu Icon">-->
<!--              <div class="flex-column">-->
<!--                <div class="menu_title bold">Change Language</div>-->
<!--                <div class="menu_desc">Switch your Language</div>-->
<!--              </div>-->
<!--              <i class="fas fa-chevron-right"></i>-->
<!--            </a>-->
<!--          </li>-->
          <li> <!--HOW IT WORKS -->
            <router-link to="/home/howItWorks">
              <img src="/static/images/menu/menu_item_how.png" alt="Menu Icon">
              <div class="flex-column">
                <div class="menu_title bold">{{ getTranslations.home_home_how_it_works }}</div>
                <div class="menu_desc">{{ getTranslations.home_home_how_it_works_text }}</div>
              </div>
              <i class="fas fa-chevron-right"></i>
            </router-link>
          </li>
          <li>
            <a @click.prevent="logoutUser" style="cursor:pointer">
              <img src="/static/images/menu/menu_item_logout.png" alt="Menu Icon">
              <div class="flex-column">
                <div class="menu_title bold">{{ getTranslations.home_home_log_out }}</div>
              </div>
              <i class="fas fa-chevron-right"></i>
            </a>
          </li>
        </div>
      </ul>
    </nav>

    <router-view v-if="isComponentCreated"></router-view>
    <main v-else></main>

    <fade-transition>
      <component :is="currentModal"
                 @close="closeHomeModal(true)"/>
    </fade-transition>
    <fade-transition>
      <component :is="modalForHomePage" v-bind="currentProperties" @close="closeHomeModal(false)"
                 @openNewModal="openNewModal($event)"></component>
    </fade-transition>

    <resume-game-modal v-if="isResumeGameModalOpen" @resume:game="handleResumeGame"></resume-game-modal>

    <pre-game-modal v-if="isPreGameModalOpen" @close:modal="isPreGameModalOpen = false"></pre-game-modal>

    <footer v-show="isComponentCreated">
      <div class="flex-row">
        <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank" class="terms">{{ getTranslations.visitor_t_and_c }}</a>
        <div class="vert_sep"></div>
        <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_privacy_and_policy')" target="_blank" class="privacy">{{ getTranslations.visitor_visitor_privacy_policy }}</a>
      </div>
    </footer>
  </div>
</template>



<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Vue from 'vue';
import $ from 'jquery';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import NewGameMixin from '@/common/mixins/home';
import RoundUpMixin from '@/common/mixins/roundUp';
import webSocket from '@/common/webSocket';
import auth from '@/common/auth';
import { listenForPushNotifications } from '@/common/serviceWorkers';
import FadeTransition from '@/components/home/sharedcomponents/FadeTransition';
import ResumeGameModal from './modals/ResumeGameModal';
import PreGameModal from './modals/pregame/PreGameModal';
import ResumeGame from './modals/ResumeGame';
import ResubscribeGame from './modals/ResubscribeGame';
import HomeScreenShortcut from './modals/HomeScreenShortcut';
import ResubscribeGameSms from './modals/ResubscribeGameSms';
import ZeroBalance from './modals/ZeroBalance';
import WelcomeSignup from './modals/WelcomeSignup';
import PrizeForFreeGame from './modals/PrizeForFreeGame';
import SpinWheelPrize from './modals/spinwheel/SpinWheelPrize';
import { handleLanguageDropdown, handleBurger, openCloseTab, hoverMenuItems } from '../../common/jQuery';
import modals from '../../common/modals'
import {removeLocalStorageValueByUser} from '../../helpers/user'
// import GameBonus from './modals/bonus_phases/daily_bonus_modals/GameBonus';
// import PointsBonus from './modals/bonus_phases/daily_bonus_modals/PointsBonus';
// import DailyBonusSpinningWheel from './modals/bonus_phases/daily_bonus_modals/DailyBonusSpinningWheel';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'home',
  mixins: [NewGameMixin, RoundUpMixin, FacebookMixin],
  components: {
    ResumeGameModal,
    PreGameModal,
    FadeTransition
  },
  data() {
    return {
      currentModal: null,
      prizeModalName: null,
      stompClient: null,
      subscription: null,
      connectionTimer: null,
      isIos: false,
      currentTabPath: null,
      showedModal: false,
      homeScreenModalApplied: null,
      homeScreenModalDenied: null,
      homeScreenModalEnable: true,
      jsonData: null,
      installPromptEvent: null,
      show: true,
      isPreGameModalOpen: false,
      isResumeGameModalOpen: false,
      isComponentCreated: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.currentTabPath === null && to.path === '/home') {
        vm.currentTabPath = to.path;
        sessionStorage.setItem('homeCurrentTabPath', vm.currentTabPath);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    // eslint-disable-next-line
    $(window).scrollTop(0);
    console.log(`from: ${from.path}`);
    console.log(`to: ${to.path}`);
    this.currentTabPath = to.path;
    this.storeModalForHomePage(null);
    console.log(`-------------------------------------- beforeRouteUpdate: ${this.currentTabPath} + ${sessionStorage.getItem('homeCurrentTabPath')} + ${to.path} `);
    sessionStorage.setItem('homeCurrentTabPath', to.path);
    next();
  },
  created() {
    /**
     * If the current page is 'home' we will check it from 'DefaultContent.vue' component,
     * because we should also show the level up modal.
     * */
    if (sessionStorage.getItem('toPage') !== '/home') {
      this.checkIsGameInProgress();
    }

    // eslint-disable-next-line
    if (this.availableIntegrations.CROSS_IRAQ && this.integrationHeader === this.availableIntegrations.CROSS_IRAQ.name && (sessionStorage.getItem('isRun') === null || sessionStorage.getItem('isRun') === 'false')) {
      if (document.getElementById('db_response')) {
        document.removeChild('korek_response');
        document.removeChild('db_response');
      }
      sessionStorage.setItem('isRun', 'true');
    }
    listenForPushNotifications();
    console.log('GAMEPLAY VALUE: ', this.swipoGameThemes);
    this.currentTabPath = sessionStorage.getItem('homeCurrentTabPath');
    console.log(`-------------------------------------- created hook: ${this.currentTabPath} `);
    console.log('Home\'s created hook');
    console.log('this.userDetails:', this.userDetails);
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.getUserAchievements();
    // this.storePerformance(this.userDetails.msisdn);
    this.homeScreenModalApplied = localStorage.getItem('homeScreenModalApplied');
    this.homeScreenModalDenied = sessionStorage.getItem('homeScreenModalDenied');
    if (this.homeScreenModalApplied || this.homeScreenModalDenied || this.userDetails.hasPhoneShortcut) this.storeHomeScreenModalDisable(true);
    this.getBonusPhases().then(() => {
      this.getUserNotifications().then(() => {
        // example url for extra Notifications from SocketJS -- http://localhost:8181/api/sendNotifications?msisdn=300136987410
        this.stompClient = webSocket.getNotificationsStompClient();
        if (this.stompClient === null) {
          this.stompClient = webSocket.createNewStompClient('/notificationsData');
        }
        this.connect();
        if (this.bonusDailyModal) {
          if (this.phoneShortcutEnabled && this.shortCutModalEnable()) {
            if (this.firstTimeEntry) {
              this.storeModalForHomePage(HomeScreenShortcut);
              this.showModal().then(() => {
                console.log('hr8eee');
                this.setFirstTimeEntry(true);
                this.methodForPopUps();
              });
            } else {
              this.storeModalForHomePage(HomeScreenShortcut);
              this.showModal();
            }
          }
        }

        this.isComponentCreated = true;
      });
    });
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', this.beforeInstallPromptHandler);
    console.log(`-------------------------------------- Mounted hook: ${this.userDetails.availableGames}`);
    this.$nextTick(() => {
      handleLanguageDropdown();
      handleBurger(ZeroBalance);
      hoverMenuItems();
    });
    console.log('EVENT AFTER THIS:', this.getInstallPromptEvent);
    // this.autoCheckIfGameToResumeExists();
    openCloseTab();
  },
  updated() {
    // eslint-disable-next-line
    console.log('Username from db: ' + this.userDetails.username + ' username from Storage: ' + localStorage.getItem('username')
      + ' jwtToken From LocalStorage: ' + localStorage.getItem('jwtToken')
      + ' jwtToken From SessionStorage' + sessionStorage.getItem('jwtToken'));
    if (this.userDetails.username !== '') {
      // eslint-disable-next-line
      console.log('Home.js for skip refresh case');
      if (!((localStorage.getItem('username') === this.userDetails.username))
        && (localStorage.getItem('jwtToken') !== null && sessionStorage.getItem('jwtToken') === null)) {
        // eslint-disable-next-line
        console.log('Inside Case with Multiple Users...');
        // eslint-disable-next-line
        window.location.reload();
      }
      if (localStorage.getItem('jwtToken') !== null && sessionStorage.getItem('jwtToken') !== null) {
        // eslint-disable-next-line
        console.log('Inside Case with Multiple Users LOCAL & STORAGE...');
        sessionStorage.clear();
        // eslint-disable-next-line
        window.location.reload();
      }
    }
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'storeHomeScreenModalDisable',
      'setInstallPromptEvent',
    ]),
    ...mapActions('common', [
      'facebookSDKApi',
    ]),
    ...mapMutations('profile', [
      'storeNotificationsFromSocket',
      'setFirstTimeEntry',
      'clearAllData',
    ]),
    // ...mapActions('profile', [
    //   'storePerformance',
    // ]),
    ...mapMutations('game', [
      'resetPrizePostGameData',
    ]),
    ...mapActions('game', [
      'checkIfGameToResumeExists',
      'awardPrizeAction',
    ]),
    ...mapActions('profile', [
      'storeAvailablePrizeTypes',
      'storeVisitorWinners',
      'getUserAchievements',
      'getUserNotifications',
      'subscribeUserForOnlineChannelAndThenOpenTheChannel',
      'getBonusPhases',
    ]),
    ...mapActions('i18n', [
      'getTranslationsFile',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'changeCSSFile',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
    ]),
    checkIsGameInProgress () {
      if (localStorage.getItem('isGameInProgress')) {
        const isGameInProgress = removeLocalStorageValueByUser('isGameInProgress', this.userDetails.msisdn);

        if (isGameInProgress) {
          this.isResumeGameModalOpen = true;

          modals.setupCommonModal({
            hideImmediate: true,
            afterHideCallback: () => {
              this.isResumeGameModalOpen = false;

              this.goToHome();
            }
          })
        }
      }
    },
    handleResumeGame () {
      modals.hideCommonModal({
        immediate: true,
        afterHideCallback: () => {
          this.isResumeGameModalOpen = false;

          this.isPreGameModalOpen = true;
        }
      });
    },
    playGameMethod() {
      this.playGame();
    },
    closeHomeModal(isCurrentModal) {
      if (isCurrentModal) this.currentModal = null; else this.storeModalForHomePage(null);
      if (!this.currentModal && !this.modalForHomePage) {
        /* eslint-disable */
        $(".popup_box").fadeOut(200);
        $(".overlay").fadeOut(200);
        $('.modal, .modal-overlay').fadeOut();
        $("body").removeClass("modal-open");
        /* eslint-enable */
      } else {
        this.showModal();
      }
    },
    createLink() {
      const manifestData = this.jsonData;
      manifestData.name = this.getTranslations.home_manifest_file_title;
      manifestData.short_name = this.getTranslations.home_manifest_file_title;
      manifestData.icons[0].src = this.getTranslations.home_manifest_file_image1;// Assuming the first icon is being changed
      manifestData.icons[1].src = this.getTranslations.home_manifest_file_image2;
      // Create a new JSON string with the modified data
      const modifiedManifestJson = JSON.stringify(manifestData);
      // Create a Blob from the modified JSON
      const blob = new Blob([modifiedManifestJson], { type: 'application/json' });
      console.log('BLOB', blob);
      // Create a URL for the Blob
      const manifestBlobUrl = URL.createObjectURL(blob);
      console.log('manifestBlobUrl', manifestBlobUrl);
      // Create a link element to add to the head
      // const manifestLink = document.createElement('link');
      // manifestLink.rel = 'manifest';
      // manifestLink.href = manifestBlobUrl;
      // Find the existing link element for the manifest
      const manifestLink = document.querySelector('link[rel="manifest"]');
      // Update the href attribute of the link element
      manifestLink.href = manifestBlobUrl;
      // Append the link element to the head
      document.head.appendChild(manifestLink);
    },
    beforeInstallPromptHandler(event) {
      event.preventDefault();
      // Store the event to prompt the user later
      console.log('EVENT', event);
      sessionStorage.setItem('shortCutEvent', event);
      this.setInstallPromptEvent(event);
    },
    /* eslint-disable */
    shortCutModalEnable() {
      if (window.matchMedia('(display-mode: standalone)').matches) {
        // The PWA is installed
        console.log('PWA is installed');
        this.storeHomeScreenModalDisable(true);
        return false;
      }
      if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        console.log('not a mobile');
        this.storeHomeScreenModalDisable(true);
        return false;
      }
      if (this.phoneShortcutEnabled) return this.homeScreenModalApplied === 'true' ? false : !(this.homeScreenModalDenied === 'true');
      this.storeHomeScreenModalDisable(true);
      return false;
    },
    closeModalForHomeScreen() {
      sessionStorage.setItem('homeScreenModalDenied', 'true');
      this.storeHomeScreenModalDisable(true);
    },
    successInstall() {
      this.storeHomeScreenModalDisable(true);
    },
    openNewModal(event) {
      this.storeModalForHomePage(null);
      this.prizeModalName = event;
      this.storeModalForHomePage(SpinWheelPrize);
      this.showModal();
    },
    autoCheckIfGameToResumeExists() {
      this.checkIfGameToResumeExists().then(() => {
        console.log('this.gameInProgress:', this.gameInProgress);
        if (this.gameInProgress) {
          console.log('showing resume game pop up...');
          this.storeModalForHomePage(ResumeGame);
          const vm = this;
          this.$nextTick(() => {
            /* eslint-disable */
            // open modal
            $('.modal,.modal-overlay,.overlay').fadeIn(200);
            $("body").addClass("modal-open");
            // hide modal
            $('.modal-close, .modal-overlay,.btn_close, .overlay').click(function () {
              $(".popup_box").fadeOut(200);
              $(".overlay").fadeOut(200);
              $('.modal, .modal-overlay').fadeOut();
              $("body").removeClass("modal-open");
              /* eslint-enable */
              vm.storeModalForHomePage(null);
            });
          });
        } else {
          this.methodForPopUps();
        }
      }).catch(error => console.error(error));
    },
    methodForPopUps() {
      /* eslint-disable */
      if (this.firstTimeEntry) {
        this.currentModal = WelcomeSignup;
        this.showModal();
      } else {
        if (this.unauthorizedWinnerInfo.existPrize) {
          if (this.unauthorizedWinnerInfo.msisdn === this.userDetails.msisdn) { // case where he wins a prize and login with a different user
            this.storeModalForHomePage(PrizeForFreeGame);
            this.awardPrizeAction();
            this.showModal();
          } else {
            this.resetPrizePostGameData();
          }
        } else {
          const nowDate = new Date(moment().format('L'));
          const latestLogin = new Date(sessionStorage.getItem('zeroBalancePopUp'));
          if (((nowDate.getTime() > latestLogin.getTime()) || sessionStorage.getItem('zeroBalancePopUp') === null) && (this.userDetails.availableGames === 0 && this.userDetails.subscribed) && (sessionStorage.getItem('homeCurrentTabPath') === '/home')) {
            this.storeModalForHomePage(ZeroBalance);
            this.showModal();
            sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
          }
          if (!this.userDetails.subscribed && (!this.bonusDailyModal) && (!this.gameInProgress) && sessionStorage.getItem('homeCurrentTabPath') === '/home') {
            if (this.subAndUnsubViaSMS) {
              if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                this.storeModalForHomePage(ResubscribeGameSms);
              } else {
                this.storeModalForHomePage(ResubscribeGame);
              }
            } else {
              this.storeModalForHomePage(ResubscribeGame);
            }
            this.showModal();
          }
        }
        console.log(this.homeScreenModalDisable);
        console.log('this.homeScreenModalDisable');

        if (this.shortCutModalEnable() && !this.homeScreenModalDisable && this.userDetails.subscribed && (!this.bonusDailyModal) && (!this.gameInProgress) && sessionStorage.getItem('homeCurrentTabPath') === '/home') {
          this.storeModalForHomePage(HomeScreenShortcut);
          this.showModal();

        }
      }
    },
    connect() {
      this.stompClient.connect({ Authorization: auth.getJwt() }, this.stompSuccess, this.stompFailure);
    },
    stompSuccess(frame) {
      clearTimeout(this.connectionTimer);
      // eslint-disable-next-line
      console.log(`In Home component: ${frame}`);
      console.log(`Inside Created ${this.userDetails.msisdn}`);
      console.log(`Subscribing to channel: /topic/notifications/${this.userDetails.msisdn}`);
      this.subscription = this.stompClient.subscribe(`/topic/notificationsData/${this.userDetails.msisdn}`, (response) => {
        console.log('==> Inside notification response');
        const notificationsDTO = JSON.parse(response.body);
        this.storeNotificationsFromSocket({ notifications: notificationsDTO });
        console.log('notificationsDTO');
        console.log(notificationsDTO);
      }, (errorResponse) => { // error callback
        console.log('errorResponse');
        console.log(errorResponse);
      });
    },
    stompFailure(error) {
      // console.clear();
      console.log(error);
      console.error('Lost connection to WebSocket! Reconnecting in 3 seconds...');
      clearTimeout(this.connectionTimer);
      this.connectionTimer = setTimeout(() => {
        this.stompClient = webSocket.createNewStompClient('/notificationsData');
        this.connect();
      }, 3000);
    },
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        // show/hide modal
        $('.modal-close,.modal-overlay,.overlay,.btn_close').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          if (this.firstTimeEntry) {
            this.setFirstTimeEntry(false);
            this.currentModal = null;
            this.methodForPopUps();
          } else {
            if (!this.showedModal) {
              console.log("----------------------- Correct Exit For  Store showHideModal");
              this.resetPrizePostGameData();
              this.showedModal = true;
              this.storeModalForHomePage(null);
            } else {
              this.storeModalForHomePage(null);
            }
          }
        });
      });
      /* eslint-enable */
    },
    changeLanguage(newValue) {
      console.log(`New Language ${newValue}`);
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.updateUserLanguage().then(()=>{
        window.location.reload();
      });
      /*this.getTranslationsFile().then(() => {
        moment.locale(this.getLocale.toLowerCase());
        this.updateUserLanguage().then(() => {
          this.storeVisitorWinners(localStorage.getItem('locale')).then(() => {
            this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
              this.facebookSDKApi().then(() => {
                this.changeCSSFile();
                this.getUserAchievements();
              });
            });
          });
        });
      });*/
    },
    getActiveTabClass(path) {
      return this.currentTabPath === path ? 'active' : '';
    },
    getActiveTabLocale(key) {
      return this.getLocale === key ? 'active' : '';
    },
    goToHome() {
      this.$router.push('/home');
    },
    goToNotifications() {
      this.$router.push('/home/notifications');
    },
    goToStore() {
      this.$router.push('/home/store');
    },
    goToProfile() {
      this.$router.push('/home/profile');
    },
    logoutUser() {
      this.closeAllStompClients();
      let currentLocale = localStorage.getItem('locale');
      if (currentLocale === undefined || currentLocale === null) currentLocale = this.getLocale;
      const soundsOn = localStorage.getItem('soundsOn');
      const musicOn = localStorage.getItem('musicOn');
      const levelUp = localStorage.getItem('levelUp');
      localStorage.clear();
      localStorage.setItem('locale', currentLocale);
      localStorage.setItem('soundsOn', soundsOn);
      localStorage.setItem('musicOn', musicOn);
      localStorage.setItem('levelUp',levelUp);
      sessionStorage.clear();
      if (this.userDetails.availableGames === 0) sessionStorage.setItem('zeroBalancePopUp', moment().format('L'));
      this.clearAllData();
      window.location.reload();
      this.$router.push('/');
    },
    closeAllStompClients() {
      if (this.subscription) this.subscription.unsubscribe();
      webSocket.disconnectStompClient(this.stompClient);
    },
    updateBM() {
      $('.mobile-menu__container').removeClass('open');
      $('.mobile-menu__icon').removeClass('open');
    },
  },
  computed: {
    ...mapState('common', [
      'phoneShortcutEnabled',
      'homeScreenModalDisable',
      'hideStore',
      'multiOperatorInfo',
      'swipoGameThemes',
      'hideLangSelection',
      'hideWinners',
      'hideLeaderboard',
      'reoptinAndOptoutConfig',
      'userDetails',
      'modalForHomePage',
      'subAndUnsubViaSMS',
      'integrationHeader',
      'availableIntegrations',
      'facebookFunctionality',
    ]),
    ...mapState('game', [
      'gameInProgress',
      'unauthorizedWinnerInfo',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
      'firstTimeEntry',
      'notifications',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
      'getTranslationByOperator',
      'getDisplayedLocale',
    ]),
    ...mapState('i18n', [
      'availableLocales',
      'getInstallPromptEvent',
    ]),
    hasUnreadNotifications () {
      return this.notifications.filter(({readStatus}) => (typeof readStatus === 'boolean') && !readStatus).length > 0
    },
    currentProperties() {
      if (this.modalForHomePage === SpinWheelPrize) {
        return {
          prizeInfo: {
            prizeName: this.prizeModalName,
          },
        };
      }
      return null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/Home.vue